import { MDBContainer } from "mdb-react-ui-kit";
import { useEffect, useState } from "react";
import { DataTable } from "stm-frontend-library";
import {
  getJournals,
  getSubjects,
  showErrorToast,
  updateJournalSubjects,
} from "../../helpers";
import { columns } from "./columns";
import SubjectsProvider from "./SubjectsContext";
import { SELECTED_JOURNAL_IDS_KEY } from "../../constants";
import { getSelectedJournalIds } from "../../helpers/journals";

const Journals = () => {
  const [data, setData] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [lastSelectedRow, setLastSelectedRow] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const { data: response } = await getJournals();
        const arrResponse = response?.journals ?? [];

        const selectedJournalIds = await getSelectedJournalIds();

        const mappedArrResponse = arrResponse.map((journal) => {
          const isJournalSelected = selectedJournalIds.includes(journal.id);

          return {
            ...journal,
            clickEvent(row) {
              setLastSelectedRow(row);
            },
            preselected: isJournalSelected,
          };
        });

        setData(mappedArrResponse);
      } catch (error) {
        showErrorToast();
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        setIsLoading(true);
        const response = await getSubjects();

        setSubjects(response.data);
      } catch (error) {
        showErrorToast();
      } finally {
        setIsLoading(false);
      }
    };

    fetchSubjects();
  }, []);

  const onSubjectsSave = async (subjects) => {
    setIsLoading(true);

    try {
      await updateJournalSubjects({
        journal_id: lastSelectedRow.id,
        subjects_ids: subjects.map((s) => s.id),
      });

      window.location.reload();
    } catch (error) {
      showErrorToast();
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectRow = (checked, row) => {
    let selectedJournalIds = JSON.parse(
      localStorage.getItem(SELECTED_JOURNAL_IDS_KEY) || []
    );

    if (selectedJournalIds.includes(row.id) && !checked) {
      selectedJournalIds = selectedJournalIds.filter((id) => id !== row.id);
    } else {
      selectedJournalIds.push(row.id);
    }

    localStorage.setItem(
      SELECTED_JOURNAL_IDS_KEY,
      JSON.stringify(selectedJournalIds)
    );
  };

  const handleSelectAllRows = (checked, rows) => {
    localStorage.setItem(
      SELECTED_JOURNAL_IDS_KEY,
      JSON.stringify(rows.map((j) => j.id))
    );
  };

  return (
    <MDBContainer className="my-5">
      <SubjectsProvider subjects={subjects} onSave={onSubjectsSave}>
        <DataTable
          isLoading={isLoading}
          rows={data}
          columns={columns}
          enableRowSelection={true}
          onSelectRow={handleSelectRow}
          onSelectAllRows={handleSelectAllRows}
        />
      </SubjectsProvider>
    </MDBContainer>
  );
};

export default Journals;
